import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'tagBoxValuePipe',
  standalone: true,
})
export class TagBoxValuePipePipe implements PipeTransform {
  transform(value: Array<number> | string,): Array<number | string> | null {
    if(typeof value === 'string' && value.length >0){
      return value.split(',').map((x) => isNaN(Number(x)) ? x : Number(x));
    } else if (Array.isArray(value) && value.length >0){
      return value;
    }else{
      return null;
    }
  }
}
